import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        paginationWrapper: {
            marginTop: theme.spacing(1),
            display: 'flex',
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'right',
        },
        tableContainer: {
            padding: theme.spacing(0, 0.5),
            minHeight: '100px',
            boxSizing: 'border-box',
        },
    }
})

export default useStyles
